/** @format */

import { useCallback, useEffect, useState } from 'react';
import { useNavbar } from '../../../../modules/navbar';
import { useModal } from '../../../../modules/ui';
import { useHistory } from 'react-router-dom';
import { getLocalStorageLng, getAPILanguage } from 'utils/utils';
import i18n from 'i18next';

export const useProfileModal = () => {
	const localizedLang = getLocalStorageLng();
	const history = useHistory();
	const { boundToggleRightSidebar } = useModal();
	const { RAZZLE_CDN_URL } = process.env;
	const [lngOpen, setLngOpen] = useState(false);
	const [language, setLanguage] = useState(
		getAPILanguage() == 'en-US' ? 'English' : '中文'
	);

	const {
		aud,
		navbarData,
		avatars,
		fanAmount,
		followingAmount,
		friendAmount,
		meetupAmount,
		applyAmount,
		boundFetchUserDetail,
		boundClearUserData,
		boundRemoveToken
	} = useNavbar();

	useEffect(() => {
		if (aud) {
			boundFetchUserDetail();
		}
	}, [aud]);

	const amount = meetupAmount.amount + applyAmount.amount;

	const logOut = useCallback(() => {
		boundRemoveToken();
		boundClearUserData();
		history.push(`/${localizedLang}/login`);
	}, [boundRemoveToken, localizedLang]);

	const directoProfile = useCallback(() => {
		try {
			boundToggleRightSidebar(false);
			if (navbarData) {
				history.push(`/${localizedLang}/profile/${aud}`);
			} else {
				history.push(`/${localizedLang}/signup`);
			}
		} catch (e) {
			console.log('e: ', e);
		}
	}, [localizedLang, aud]);

	const gotoOtherPage = useCallback(
		(page) => {
			boundToggleRightSidebar(false);
			history.push(`/${localizedLang}/${page}`);
		},
		[localizedLang]
	);

	const setActiveTab = useCallback((e) => {
		e.preventDefault();
		const lngValue = e.target.innerText;
		const pathname = window.location.pathname.split('/').slice(2).join('/');
		if (lngValue === 'English') {
			setLngOpen(false);
			history.push(`/en/${pathname}`);
			i18n.changeLanguage('en');
		}

		if (lngValue === '中文') {
			setLngOpen(false);
			history.push(`/zh-tw/${pathname}`);
			i18n.changeLanguage('zh-TW');
		}

		setLanguage(getAPILanguage() == 'en-US' ? 'English' : '中文');
	}, []);

	const url =
		aud && avatars && avatars[0]
			? `${RAZZLE_CDN_URL}/member/${aud}/avatar/${avatars[0]}`
			: 'https://journalism.berkeley.edu/wp-content/uploads/profile-placeholder.png';
	return {
		aud,
		url,
		navbarData,
		avatars,
		amount,
		fanAmount,
		followingAmount,
		friendAmount,
		lngOpen,
		language,
		giftPoints: navbarData ? navbarData.giftPoints : 0,
		totalPoints: navbarData ? navbarData.totalPoints : 0,
		logOut,
		setLngOpen,
		setActiveTab,
		directoProfile,
		gotoOtherPage
	};
};
